import { useState, useEffect } from "react";
import { EventParticipation } from "../eventParticipation/EventParticipation";
import { UserPointHistoryList } from "./UserPointHistoryList";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import { requestManagePointAuth } from "../../api/Companies.api";
import { auth } from "../../firebase";
import { possessedPointMap } from "../../model/Users";
import userQuery from "../../firestore/User.query";
import { UserData } from "../../model/Users";
import { Company } from "../../model/Companies";

type Props = {
  targetUserId?: string | undefined;
  companyDisplayId?: string | undefined;
  company?: Company | undefined;
};

export const HistoryDisplayTab = ({
  targetUserId = undefined,
  companyDisplayId = undefined,
  company = undefined,
}:Props) => {

  const activeTabStyle = " border-b-white cursor-default";
  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;
  const tenantId = currentUser?.tenantId;
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState<string>("eventParticipation");
  const [pointFlg, setPointFlg] = useState<boolean>(false);
  const [heldPoints, setHeldPoints] = useState<number | undefined>(0);
  const [submitFlg, setSubmitFlg] = useState<boolean>(false);

  useEffect(() => {
    const f = async () => {
      try {
        // ポイント管理権限の有無を取得
        const managePointAuth = await requestManagePointAuth(tenantId!);
        setPointFlg(managePointAuth.data);      
        // 保有ポイントを計算
        if(targetUserId && companyDisplayId){
          // 利用者情報を取得(調整登録後の保有ポイント数を取得する)
          const user = await userQuery.getUser(currentUser?.tenantId!, companyDisplayId + targetUserId) as UserData;
          const possessedPointMap = user.possessedPointMap;
          if(possessedPointMap){
            let optionResult: possessedPointMap[] = [];
            let pointAcc: number | undefined = 0;
            let point: number | undefined = 0;
            const possessedPointKeys = Object.keys(possessedPointMap);
            for(let i = 0; i < possessedPointKeys.length; i++){
              const key = Number(possessedPointKeys[i]);
              let possessedPoint = possessedPointMap[key].point;
              if(possessedPoint != undefined){
                point = possessedPoint + pointAcc;
                pointAcc = point;
              }
            }
            setHeldPoints(pointAcc);
          };
        }
      } catch (err: any) {
        console.error(err);
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
      }
    };
    f();
  }, [submitFlg]);
  return (
    <div>
      <div className="pt-6 px-6">
        <div className="sm:flex-auto">
          <h2 className="text-xl font-semibold text-gray-900">
            履歴表示
          </h2>
        </div>
        <ul className="pt-3 flex flex-wrap text-sm text-center">
          <li className="pl-2 border-b border-gray-400"/>
          <li className="eventParticipation">
            <button
              className={`border border-gray-400 w-[150px] inline-block px-4 py-3 active dark:bg-gray-800 rounded-t-lg ${activeTab === "eventParticipation" ? activeTabStyle : "bg-stone-200"}`}
              onClick={() => setActiveTab("eventParticipation")}
            >
              イベント参加履歴
            </button>
          </li>
          {pointFlg ?
            <li className="point">
              <button
                className={`border border-gray-400 w-[150px] inline-block px-4 py-3 active dark:bg-gray-800 rounded-t-lg ${activeTab === "point" ? activeTabStyle : "bg-stone-200"}`}
                onClick={() => setActiveTab("point")}
              >
                ポイント履歴
              </button>
            </li>
          : <></>
          }
          <li className="flex-grow border-b border-gray-400">
            {pointFlg ?
                <h2 className="text-left ml-10 mt-3 text-blue-800 font-medium">
                    保有ポイント数：{heldPoints == undefined ? "0" : heldPoints}
                </h2>
                : <></>
              }
          </li>
        </ul>
      </div>

      <div className={activeTab === "eventParticipation" ? "" : "hidden"}>
        <EventParticipation 
          targetUserId={targetUserId}
        />
      </div>
      <div className={activeTab === "point" ? "" : "hidden"}>
        <UserPointHistoryList
          setSubmitFlg={setSubmitFlg}
          submitFlg={submitFlg}
          company={company}
        />
      </div>
    </div>
  );
};
